import type { TFunction } from 'i18next';

export interface LandxmlMergeWarningDetail {
  code: 'MISSING_LINEAR_UNIT' | 'MISSING_CRS';
  sourceName: string;
  projectSrid?: number;
}

export interface LandxmlMergeStatsWarnings {
  warnings?: string[];
  warningDetails?: LandxmlMergeWarningDetail[];
  unsupportedSections?: string[];
}

export function landxmlMergeWarningTexts(stats: LandxmlMergeStatsWarnings | null | undefined, t: TFunction<'project'>): string[] {
  const assumptions = stats?.warningDetails === undefined
    ? (stats?.warnings ?? [])
    : stats.warningDetails.map((detail) => {
      if (detail.code === 'MISSING_LINEAR_UNIT') {
        return t('landxmlMerge.warningDetails.missingLinearUnit', { sourceName: detail.sourceName });
      }
      return detail.projectSrid == null
        ? t('landxmlMerge.warningDetails.missingCrs', { sourceName: detail.sourceName })
        : t('landxmlMerge.warningDetails.missingCrsWithSrid', {
          sourceName: detail.sourceName, projectSrid: detail.projectSrid,
        });
    });
  return [...assumptions, ...(stats?.unsupportedSections ?? [])];
}
